export enum DeviceSubscriptionStatus {

    noSubscription = "Subscription.noSubscription",
    expired = "Subscription.expired",
    failedToCheck = "Subscription.failedToCheck",
    active = "Subscription.active"
}
